/* floating-toolbar.tsx generated by @compiled/babel-plugin v0.36.1 */
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./floating-toolbar.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { AI_SUGGESTION_TRIGGERED_FROM } from '@atlaskit/editor-common/analytics';
import { Pressable } from '@atlaskit/primitives/compiled';
import { insertInlineSuggestionWithAnalytics } from '../commands/commands-with-analytics';
import { SuggestionManager } from '../handlers/suggestion-manager';
import { getPluginState as getInlineSuggestionsPluginState } from '../plugin-factory';
import { InlineNodeRenderer } from './utils';
var styles = {
  pressable: "_bfhksm61 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t"
};
export var InlineSuggestionToolbar = /*#__PURE__*/function () {
  function InlineSuggestionToolbar() {
    _classCallCheck(this, InlineSuggestionToolbar);
  }
  return _createClass(InlineSuggestionToolbar, null, [{
    key: "shouldShow",
    value: function shouldShow(suggestion, selection) {
      return suggestion.from <= selection.from && suggestion.to >= selection.to;
    }
  }, {
    key: "createToolbarItem",
    value: function createToolbarItem(inlineSuggestion, api) {
      return {
        type: 'custom',
        render: function render(view) {
          if (!view || !inlineSuggestion.suggestedNode) {
            return null;
          }
          return /*#__PURE__*/React.createElement(Pressable, {
            xcss: styles.pressable,
            onClick: function onClick() {
              var _api$analytics;
              insertInlineSuggestionWithAnalytics(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)(AI_SUGGESTION_TRIGGERED_FROM.TOOLBAR)(view.state, view.dispatch);
              view.focus();
            }
          }, /*#__PURE__*/React.createElement(InlineNodeRenderer, {
            node: inlineSuggestion.suggestedNode
          }));
        },
        fallback: []
      };
    }
  }, {
    key: "buildToolbarConfig",
    value: function buildToolbarConfig(inlineSuggestion, state, api) {
      var _state$schema$nodes = state.schema.nodes,
        paragraph = _state$schema$nodes.paragraph,
        heading = _state$schema$nodes.heading,
        taskItem = _state$schema$nodes.taskItem,
        decisionItem = _state$schema$nodes.decisionItem,
        caption = _state$schema$nodes.caption;
      return {
        title: 'Inline suggestions',
        getDomRef: function getDomRef() {
          var anchor = document.querySelector(".".concat(SuggestionManager.INLINE_SUGGESTION_DECORATION_CLASSES.toolbarAnchor));
          return anchor instanceof HTMLElement ? anchor : undefined;
        },
        nodeType: [paragraph, heading, taskItem, decisionItem, caption].filter(function (nodeType) {
          return !!nodeType;
        }),
        items: [this.createToolbarItem(inlineSuggestion, api)],
        align: 'left',
        className: this.INLINE_SUGGESTION_FLOATING_TOOLBAR_CLASS
      };
    }
  }, {
    key: "maybeBuild",
    value: function maybeBuild(state, api) {
      var _getInlineSuggestions = getInlineSuggestionsPluginState(state),
        inlineSuggestion = _getInlineSuggestions.inlineSuggestion;
      if (!inlineSuggestion) {
        return undefined;
      }
      if (this.shouldShow(inlineSuggestion, state.selection)) {
        return this.buildToolbarConfig(inlineSuggestion, state, api);
      }
      return undefined;
    }
  }]);
}();
_defineProperty(InlineSuggestionToolbar, "INLINE_SUGGESTION_FLOATING_TOOLBAR_CLASS", 'proactive-ai-inline-suggestion-floating-toolbar');